const MARKETPLACE_ACTIONS = {
  CARD_CLICK: 'Marketplace > Explore > Click on the card',
  GET_BTN_CLICK: 'Marketplace > Get it now',
  ADD_BTN_CLICK: 'Marketplace > Add',
  MENU_EXPLORE: 'Marketplace > Explore',
  MENU_POWER_POINT: 'Marketplace > PowerPoint',
  MENU_TEAMS: 'Marketplace > Microsoft Teams',
  MENU_ZOOM: 'Marketplace > Zoom',
  MENU_GOOGLE_SLIDES: 'Marketplace > Google Slides',
  MENU_CHAT_GPT: 'Marketplace > ChatGPT',
  TIP_CLICK: 'Marketplace > Click on the text link',
}

export {
  MARKETPLACE_ACTIONS,
}
